import { FC } from 'react';

import { ProductPage } from '@bpm-web-app/components/src/lib/supreme-account/products/product';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const AccountProductPage: FC<AccountPageProps> = (props) => <ProductPage {...props} />;

export default AccountProductPage;
